/*
    BEEP BOP BOOP - I AM AN AUTO GENERATED FILE - DO NOT EDIT ME MANUALLY
*/


// Name: Events JSON Schemas 

const _ACTION_ITEM_JSON_SCHEMA = {
    "$ref": "#/definitions/ActionItemSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "ActionItemSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "action_item_id": {
                    "format": "integer",
                    "title": "Action Item Id",
                    "type": "number"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "item_payload": {
                    "additionalProperties": {},
                    "title": "Item Payload",
                    "type": "object"
                },
                "item_uid": {
                    "reference_type": "uuid",
                    "title": "Item Uid",
                    "type": "string",
                    "uid_resource_type": "action_item"
                },
                "last_reminder_sent_timestamp": {
                    "format": "date-time",
                    "title": "Last Reminder Sent Timestamp",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "reminder_count": {
                    "format": "integer",
                    "title": "Reminder Count",
                    "type": "number"
                },
                "resource_type": {
                    "class_name": "ResourceType",
                    "enum": [
                        "unknown_resource_type",
                        "user_account",
                        "user_account_balance",
                        "user_account_balance_source",
                        "user_history_entry",
                        "balance_change_log",
                        "international_user_bank_account",
                        "us_domestic_user_bank_account",
                        "user_bank_account_delta",
                        "user_account_settings",
                        "user_account_admin_ghost",
                        "user_account_finalization",
                        "third_party_user_account_mapping",
                        "previous_email_address",
                        "pending_email_change",
                        "archived_pending_email_change",
                        "password",
                        "expired_password",
                        "password_reset",
                        "deposit",
                        "deposit_invite",
                        "deposit_adjustment",
                        "deposit_interest",
                        "deposit_history_entry",
                        "deposit_close_request",
                        "deposit_user_stats",
                        "deposit_bank_mapping",
                        "deposits_bulk_import",
                        "deposit_interest_log",
                        "archived_deposit_close_request",
                        "deposit_withheld_funds",
                        "pmc_report_timetable",
                        "deposit_group",
                        "deposit_post_close_adjustment",
                        "deposit_user_group",
                        "property_group",
                        "property_user_group",
                        "dispute",
                        "dispute_split",
                        "dispute_intervention_request",
                        "property",
                        "property_address",
                        "compliance",
                        "compliance_rule",
                        "compliance_history",
                        "email_template",
                        "email_verification",
                        "email_verification_record",
                        "email_event",
                        "sent_email",
                        "mailbox",
                        "mailbox_meta_data",
                        "mailbox_message",
                        "permission_entry",
                        "permission_log_entry",
                        "permissions_organization_settings",
                        "resource_permissions",
                        "organization",
                        "organization_resource_permission_rule",
                        "invoice",
                        "invoice_item",
                        "payment_request",
                        "stripe_payment_log",
                        "user_withdraw",
                        "priority_ach_payment",
                        "priority_ach_recurring_payment",
                        "loan_application",
                        "loan_system_info",
                        "loan",
                        "loan_history",
                        "loan_payment_log",
                        "stripe_webhook_log",
                        "user_account_payment_provider_info",
                        "sezzle_order",
                        "sezzle_webhook_event",
                        "bank_account",
                        "bank_account_historical_interest_rate",
                        "bank_account_interest",
                        "bank_account_balance_record",
                        "bank_transfer",
                        "bulk_funds_transfer",
                        "funds_lock",
                        "funds_lock_release_log",
                        "released_funds_lock",
                        "balance_source_transfer",
                        "credit_user_account_log",
                        "event",
                        "event_hook",
                        "notification",
                        "action_item",
                        "update_log_entry",
                        "storage_file",
                        "attached_storage_files",
                        "pre_uploaded_file",
                        "system_history_entry",
                        "snapshot",
                        "ip_address",
                        "known_ip_address",
                        "user_agent",
                        "known_user_agent",
                        "basic_user_account_info",
                        "system_stats",
                        "resource_note",
                        "deposify_tag",
                        "permanent_link",
                        "online_user",
                        "frontend_general_settings",
                        "yardi_screening_works_pro_xml",
                        "yardi_voyager_xml",
                        "yardi_voyager_transaction",
                        "yardi_voyager_resident",
                        "yardi_voyager_resident_custom_column",
                        "yardi_voyager_property_unit",
                        "yardi_voyager_property",
                        "yardi_voyager_pmc_service_interface_version",
                        "yardi_voyager_pmc",
                        "yardi_voyager_pmc_credentials",
                        "yardi_voyager_pet",
                        "yardi_voyager_ils_guest_card_event",
                        "yardi_voyager_charge",
                        "yardi_voyager_charge_code",
                        "yardi_voyager_deposit_create_intent",
                        "yardi_voyager_deposit_close_intent",
                        "yardi_voyager_deposit_withhold_intent",
                        "yardi_voyager_event",
                        "yardi_voyager_flex_deposit_intent",
                        "yardi_voyager_phone",
                        "yardi_voyager_other_occupant",
                        "yardi_voyager_pmc_custom_column_settings",
                        "yardi_voyager_pmc_stats",
                        "yardi_voyager_pmc_stats_collector",
                        "yardi_voyager_active_scan_log_entry",
                        "yardi_voyager_system_settings"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "resource_uid": {
                    "reference_type": "uuid",
                    "title": "Resource Uid",
                    "type": "string"
                }
            },
            "required": [
                "account_uid",
                "action_item_id",
                "created_timestamp",
                "item_payload",
                "item_uid",
                "last_reminder_sent_timestamp",
                "last_updated_timestamp",
                "reminder_count",
                "resource_type",
                "resource_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _EVENT_HOOK_JSON_SCHEMA = {
    "$ref": "#/definitions/EventHookSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "EventHookSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uids": {
                    "items": {
                        "title": "account_uids",
                        "type": "string"
                    },
                    "title": "Account Uids",
                    "type": "array"
                },
                "any_account_uid": {
                    "title": "Any Account Uid",
                    "type": "boolean"
                },
                "any_resource_type": {
                    "title": "Any Resource Type",
                    "type": "boolean"
                },
                "any_resource_uid": {
                    "title": "Any Resource Uid",
                    "type": "boolean"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "disabled": {
                    "title": "Disabled",
                    "type": "boolean"
                },
                "event_ids": {
                    "items": {
                        "format": "integer",
                        "title": "event_ids",
                        "type": "number"
                    },
                    "title": "Event Ids",
                    "type": "array"
                },
                "hook_uid": {
                    "title": "Hook Uid",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "resource_types": {
                    "items": {
                        "class_name": "ResourceType",
                        "enum": [
                            "unknown_resource_type",
                            "user_account",
                            "user_account_balance",
                            "user_account_balance_source",
                            "user_history_entry",
                            "balance_change_log",
                            "international_user_bank_account",
                            "us_domestic_user_bank_account",
                            "user_bank_account_delta",
                            "user_account_settings",
                            "user_account_admin_ghost",
                            "user_account_finalization",
                            "third_party_user_account_mapping",
                            "previous_email_address",
                            "pending_email_change",
                            "archived_pending_email_change",
                            "password",
                            "expired_password",
                            "password_reset",
                            "deposit",
                            "deposit_invite",
                            "deposit_adjustment",
                            "deposit_interest",
                            "deposit_history_entry",
                            "deposit_close_request",
                            "deposit_user_stats",
                            "deposit_bank_mapping",
                            "deposits_bulk_import",
                            "deposit_interest_log",
                            "archived_deposit_close_request",
                            "deposit_withheld_funds",
                            "pmc_report_timetable",
                            "deposit_group",
                            "deposit_post_close_adjustment",
                            "deposit_user_group",
                            "property_group",
                            "property_user_group",
                            "dispute",
                            "dispute_split",
                            "dispute_intervention_request",
                            "property",
                            "property_address",
                            "compliance",
                            "compliance_rule",
                            "compliance_history",
                            "email_template",
                            "email_verification",
                            "email_verification_record",
                            "email_event",
                            "sent_email",
                            "mailbox",
                            "mailbox_meta_data",
                            "mailbox_message",
                            "permission_entry",
                            "permission_log_entry",
                            "permissions_organization_settings",
                            "resource_permissions",
                            "organization",
                            "organization_resource_permission_rule",
                            "invoice",
                            "invoice_item",
                            "payment_request",
                            "stripe_payment_log",
                            "user_withdraw",
                            "priority_ach_payment",
                            "priority_ach_recurring_payment",
                            "loan_application",
                            "loan_system_info",
                            "loan",
                            "loan_history",
                            "loan_payment_log",
                            "stripe_webhook_log",
                            "user_account_payment_provider_info",
                            "sezzle_order",
                            "sezzle_webhook_event",
                            "bank_account",
                            "bank_account_historical_interest_rate",
                            "bank_account_interest",
                            "bank_account_balance_record",
                            "bank_transfer",
                            "bulk_funds_transfer",
                            "funds_lock",
                            "funds_lock_release_log",
                            "released_funds_lock",
                            "balance_source_transfer",
                            "credit_user_account_log",
                            "event",
                            "event_hook",
                            "notification",
                            "action_item",
                            "update_log_entry",
                            "storage_file",
                            "attached_storage_files",
                            "pre_uploaded_file",
                            "system_history_entry",
                            "snapshot",
                            "ip_address",
                            "known_ip_address",
                            "user_agent",
                            "known_user_agent",
                            "basic_user_account_info",
                            "system_stats",
                            "resource_note",
                            "deposify_tag",
                            "permanent_link",
                            "online_user",
                            "frontend_general_settings",
                            "yardi_screening_works_pro_xml",
                            "yardi_voyager_xml",
                            "yardi_voyager_transaction",
                            "yardi_voyager_resident",
                            "yardi_voyager_resident_custom_column",
                            "yardi_voyager_property_unit",
                            "yardi_voyager_property",
                            "yardi_voyager_pmc_service_interface_version",
                            "yardi_voyager_pmc",
                            "yardi_voyager_pmc_credentials",
                            "yardi_voyager_pet",
                            "yardi_voyager_ils_guest_card_event",
                            "yardi_voyager_charge",
                            "yardi_voyager_charge_code",
                            "yardi_voyager_deposit_create_intent",
                            "yardi_voyager_deposit_close_intent",
                            "yardi_voyager_deposit_withhold_intent",
                            "yardi_voyager_event",
                            "yardi_voyager_flex_deposit_intent",
                            "yardi_voyager_phone",
                            "yardi_voyager_other_occupant",
                            "yardi_voyager_pmc_custom_column_settings",
                            "yardi_voyager_pmc_stats",
                            "yardi_voyager_pmc_stats_collector",
                            "yardi_voyager_active_scan_log_entry",
                            "yardi_voyager_system_settings"
                        ],
                        "reference_type": "enum",
                        "type": "string"
                    },
                    "title": "Resource Types",
                    "type": "array"
                },
                "resource_uids": {
                    "items": {
                        "title": "resource_uids",
                        "type": "string"
                    },
                    "title": "Resource Uids",
                    "type": "array"
                },
                "url": {
                    "title": "Url",
                    "type": "string"
                }
            },
            "required": [
                "account_uids",
                "any_account_uid",
                "any_resource_type",
                "any_resource_uid",
                "created_timestamp",
                "disabled",
                "event_ids",
                "hook_uid",
                "last_updated_timestamp",
                "resource_types",
                "resource_uids",
                "url"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _EVENT_JSON_SCHEMA = {
    "$ref": "#/definitions/EventSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "EventSchema": {
            "additionalProperties": false,
            "properties": {
                "action_item_message": {
                    "title": "Action Item Message",
                    "type": "string"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_only": {
                    "title": "Deposify Only",
                    "type": "boolean"
                },
                "event_destination": {
                    "class_name": "EventDestinationType",
                    "enum": [
                        "system_history_event",
                        "user_history_event",
                        "deposit_history_event"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "event_id": {
                    "format": "integer",
                    "maximum": 2147483646,
                    "minimum": -2147483646,
                    "title": "Event Id",
                    "type": "number"
                },
                "event_type": {
                    "class_name": "EventType",
                    "enum": [
                        "object_created",
                        "object_read",
                        "object_updated",
                        "object_deleted",
                        "user_account_created",
                        "user_account_finalized",
                        "email_sent_to_user",
                        "email_verified",
                        "email_verify_failed_already_verified",
                        "email_verify_failed_bad_token",
                        "change_email",
                        "change_email_rejected",
                        "security_notice_email",
                        "password_changed",
                        "reset_password",
                        "password_change_rejected",
                        "deposit_created",
                        "deposit_close_requested",
                        "deposit_tenant_invite",
                        "deposit_accepted",
                        "deposit_rejected",
                        "deposit_close_accepted",
                        "deposit_close_rejected",
                        "deposit_close_cancelled",
                        "deposit_closed",
                        "deposit_cancelled",
                        "deposit_landlord_cancel_as_invitee",
                        "deposit_critical_admin_update",
                        "deposit_disputed",
                        "deposit_dispute_split_proposed",
                        "deposit_dispute_split_accepted",
                        "deposit_dispute_split_rejected",
                        "deposit_dispute_split_cancelled",
                        "deposit_dispute_intervention_requested",
                        "deposit_dispute_cancelled",
                        "deposit_dispute_ended",
                        "deposit_invite_used",
                        "deposit_tenant_invoice_created",
                        "deposit_tenant_invoice_cancelled",
                        "deposit_funds_withheld",
                        "log_in",
                        "log_out",
                        "forced_log_out",
                        "log_in_rejected",
                        "file_download",
                        "file_served",
                        "funds_lock_created",
                        "funds_lock_released",
                        "funds_lock_rollback",
                        "user_account_credited",
                        "credit_limit_reached",
                        "invoice_created",
                        "invoice_paid",
                        "invoice_cancelled",
                        "invoice_uncancelled",
                        "invoice_item_created",
                        "invoice_item_paid",
                        "invoice_item_cancelled",
                        "invoice_item_uncancelled",
                        "invoice_item_added_to_invoice",
                        "invoice_item_payment_notification_pushed",
                        "payment_request_created",
                        "payment_request_deleted",
                        "stripe_payment_completed",
                        "stripe_payment_rejected",
                        "stripe_payment_log_created",
                        "user_withdraw_created",
                        "user_withdraw_payment_pending",
                        "user_withdraw_completed",
                        "user_withdraw_cancelled",
                        "user_withdraw_edited",
                        "user_bank_account_created",
                        "user_bank_account_updated",
                        "user_bank_account_soft_delete",
                        "user_bank_account_hard_delete",
                        "priority_ach_payment_created",
                        "priority_ach_payment_creation_failed",
                        "priority_ach_payment_cleared",
                        "priority_ach_payment_declined",
                        "deposit_interest_cron",
                        "deposit_receipt_generated",
                        "deposit_compliance_run",
                        "deposit_payment_cleared",
                        "deposit_payment_reset",
                        "deposit_interest_enabled",
                        "deposit_interest_disabled",
                        "deposit_interest_paid_to_tenant",
                        "search_full_index_begin",
                        "search_full_index_complete"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "event_uid": {
                    "reference_type": "uuid",
                    "title": "Event Uid",
                    "type": "string",
                    "uid_resource_type": "event"
                },
                "history_message": {
                    "title": "History Message",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notification_message": {
                    "title": "Notification Message",
                    "type": "string"
                },
                "spawn_action_item": {
                    "title": "Spawn Action Item",
                    "type": "boolean"
                },
                "spawn_notification": {
                    "title": "Spawn Notification",
                    "type": "boolean"
                }
            },
            "required": [
                "action_item_message",
                "created_timestamp",
                "deposify_only",
                "event_destination",
                "event_id",
                "event_type",
                "event_uid",
                "history_message",
                "last_updated_timestamp",
                "notification_message",
                "spawn_action_item",
                "spawn_notification"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _NOTIFICATION_JSON_SCHEMA = {
    "$ref": "#/definitions/NotificationSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "NotificationSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "event_id": {
                    "format": "integer",
                    "maximum": 2147483646,
                    "minimum": -2147483646,
                    "title": "Event Id",
                    "type": "number"
                },
                "event_type": {
                    "class_name": "EventType",
                    "enum": [
                        "object_created",
                        "object_read",
                        "object_updated",
                        "object_deleted",
                        "user_account_created",
                        "user_account_finalized",
                        "email_sent_to_user",
                        "email_verified",
                        "email_verify_failed_already_verified",
                        "email_verify_failed_bad_token",
                        "change_email",
                        "change_email_rejected",
                        "security_notice_email",
                        "password_changed",
                        "reset_password",
                        "password_change_rejected",
                        "deposit_created",
                        "deposit_close_requested",
                        "deposit_tenant_invite",
                        "deposit_accepted",
                        "deposit_rejected",
                        "deposit_close_accepted",
                        "deposit_close_rejected",
                        "deposit_close_cancelled",
                        "deposit_closed",
                        "deposit_cancelled",
                        "deposit_landlord_cancel_as_invitee",
                        "deposit_critical_admin_update",
                        "deposit_disputed",
                        "deposit_dispute_split_proposed",
                        "deposit_dispute_split_accepted",
                        "deposit_dispute_split_rejected",
                        "deposit_dispute_split_cancelled",
                        "deposit_dispute_intervention_requested",
                        "deposit_dispute_cancelled",
                        "deposit_dispute_ended",
                        "deposit_invite_used",
                        "deposit_tenant_invoice_created",
                        "deposit_tenant_invoice_cancelled",
                        "deposit_funds_withheld",
                        "log_in",
                        "log_out",
                        "forced_log_out",
                        "log_in_rejected",
                        "file_download",
                        "file_served",
                        "funds_lock_created",
                        "funds_lock_released",
                        "funds_lock_rollback",
                        "user_account_credited",
                        "credit_limit_reached",
                        "invoice_created",
                        "invoice_paid",
                        "invoice_cancelled",
                        "invoice_uncancelled",
                        "invoice_item_created",
                        "invoice_item_paid",
                        "invoice_item_cancelled",
                        "invoice_item_uncancelled",
                        "invoice_item_added_to_invoice",
                        "invoice_item_payment_notification_pushed",
                        "payment_request_created",
                        "payment_request_deleted",
                        "stripe_payment_completed",
                        "stripe_payment_rejected",
                        "stripe_payment_log_created",
                        "user_withdraw_created",
                        "user_withdraw_payment_pending",
                        "user_withdraw_completed",
                        "user_withdraw_cancelled",
                        "user_withdraw_edited",
                        "user_bank_account_created",
                        "user_bank_account_updated",
                        "user_bank_account_soft_delete",
                        "user_bank_account_hard_delete",
                        "priority_ach_payment_created",
                        "priority_ach_payment_creation_failed",
                        "priority_ach_payment_cleared",
                        "priority_ach_payment_declined",
                        "deposit_interest_cron",
                        "deposit_receipt_generated",
                        "deposit_compliance_run",
                        "deposit_payment_cleared",
                        "deposit_payment_reset",
                        "deposit_interest_enabled",
                        "deposit_interest_disabled",
                        "deposit_interest_paid_to_tenant",
                        "search_full_index_begin",
                        "search_full_index_complete"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notification_payload": {
                    "additionalProperties": {},
                    "title": "Notification Payload",
                    "type": "object"
                },
                "notification_uid": {
                    "reference_type": "uuid",
                    "title": "Notification Uid",
                    "type": "string",
                    "uid_resource_type": "notification"
                },
                "resource_type": {
                    "class_name": "ResourceType",
                    "enum": [
                        "unknown_resource_type",
                        "user_account",
                        "user_account_balance",
                        "user_account_balance_source",
                        "user_history_entry",
                        "balance_change_log",
                        "international_user_bank_account",
                        "us_domestic_user_bank_account",
                        "user_bank_account_delta",
                        "user_account_settings",
                        "user_account_admin_ghost",
                        "user_account_finalization",
                        "third_party_user_account_mapping",
                        "previous_email_address",
                        "pending_email_change",
                        "archived_pending_email_change",
                        "password",
                        "expired_password",
                        "password_reset",
                        "deposit",
                        "deposit_invite",
                        "deposit_adjustment",
                        "deposit_interest",
                        "deposit_history_entry",
                        "deposit_close_request",
                        "deposit_user_stats",
                        "deposit_bank_mapping",
                        "deposits_bulk_import",
                        "deposit_interest_log",
                        "archived_deposit_close_request",
                        "deposit_withheld_funds",
                        "pmc_report_timetable",
                        "deposit_group",
                        "deposit_post_close_adjustment",
                        "deposit_user_group",
                        "property_group",
                        "property_user_group",
                        "dispute",
                        "dispute_split",
                        "dispute_intervention_request",
                        "property",
                        "property_address",
                        "compliance",
                        "compliance_rule",
                        "compliance_history",
                        "email_template",
                        "email_verification",
                        "email_verification_record",
                        "email_event",
                        "sent_email",
                        "mailbox",
                        "mailbox_meta_data",
                        "mailbox_message",
                        "permission_entry",
                        "permission_log_entry",
                        "permissions_organization_settings",
                        "resource_permissions",
                        "organization",
                        "organization_resource_permission_rule",
                        "invoice",
                        "invoice_item",
                        "payment_request",
                        "stripe_payment_log",
                        "user_withdraw",
                        "priority_ach_payment",
                        "priority_ach_recurring_payment",
                        "loan_application",
                        "loan_system_info",
                        "loan",
                        "loan_history",
                        "loan_payment_log",
                        "stripe_webhook_log",
                        "user_account_payment_provider_info",
                        "sezzle_order",
                        "sezzle_webhook_event",
                        "bank_account",
                        "bank_account_historical_interest_rate",
                        "bank_account_interest",
                        "bank_account_balance_record",
                        "bank_transfer",
                        "bulk_funds_transfer",
                        "funds_lock",
                        "funds_lock_release_log",
                        "released_funds_lock",
                        "balance_source_transfer",
                        "credit_user_account_log",
                        "event",
                        "event_hook",
                        "notification",
                        "action_item",
                        "update_log_entry",
                        "storage_file",
                        "attached_storage_files",
                        "pre_uploaded_file",
                        "system_history_entry",
                        "snapshot",
                        "ip_address",
                        "known_ip_address",
                        "user_agent",
                        "known_user_agent",
                        "basic_user_account_info",
                        "system_stats",
                        "resource_note",
                        "deposify_tag",
                        "permanent_link",
                        "online_user",
                        "frontend_general_settings",
                        "yardi_screening_works_pro_xml",
                        "yardi_voyager_xml",
                        "yardi_voyager_transaction",
                        "yardi_voyager_resident",
                        "yardi_voyager_resident_custom_column",
                        "yardi_voyager_property_unit",
                        "yardi_voyager_property",
                        "yardi_voyager_pmc_service_interface_version",
                        "yardi_voyager_pmc",
                        "yardi_voyager_pmc_credentials",
                        "yardi_voyager_pet",
                        "yardi_voyager_ils_guest_card_event",
                        "yardi_voyager_charge",
                        "yardi_voyager_charge_code",
                        "yardi_voyager_deposit_create_intent",
                        "yardi_voyager_deposit_close_intent",
                        "yardi_voyager_deposit_withhold_intent",
                        "yardi_voyager_event",
                        "yardi_voyager_flex_deposit_intent",
                        "yardi_voyager_phone",
                        "yardi_voyager_other_occupant",
                        "yardi_voyager_pmc_custom_column_settings",
                        "yardi_voyager_pmc_stats",
                        "yardi_voyager_pmc_stats_collector",
                        "yardi_voyager_active_scan_log_entry",
                        "yardi_voyager_system_settings"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "resource_uid": {
                    "reference_type": "uuid",
                    "title": "Resource Uid",
                    "type": "string"
                }
            },
            "required": [
                "account_uid",
                "created_timestamp",
                "event_id",
                "event_type",
                "last_updated_timestamp",
                "notification_payload",
                "notification_uid",
                "resource_type",
                "resource_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};


export const ACTION_ITEM_JSON_SCHEMA = _ACTION_ITEM_JSON_SCHEMA.definitions.ActionItemSchema;
export const EVENT_HOOK_JSON_SCHEMA = _EVENT_HOOK_JSON_SCHEMA.definitions.EventHookSchema;
export const EVENT_JSON_SCHEMA = _EVENT_JSON_SCHEMA.definitions.EventSchema;
export const NOTIFICATION_JSON_SCHEMA = _NOTIFICATION_JSON_SCHEMA.definitions.NotificationSchema;
